import React, {
  ComponentType,
  LazyExoticComponent,
  Suspense,
} from 'react';

type Props<TProps extends object> = {
  Component: LazyExoticComponent<ComponentType<TProps>>;
  componentProps?: TProps;
};

export default function LazyLoadComponent<TProps extends object>({
  Component,
  componentProps,
}: Props<TProps>) {
  return (
    <Suspense>
      <Component {...(componentProps as TProps)} />
    </Suspense>
  );
}
